/*
  Functions to help transform the delta response that the editor uses
  and the DB stores (to retain blots). Use quillDetlaTo* funcs to
  convert to html/text just before it's used.
  See docs for delta shape/useage: https://quilljs.com/docs/delta
*/
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { Delta } from "./types";
import {} from "./index";

export const quillDeltaToPlaintext = (delta: Delta): string => delta.ops.reduce((text, op) => {
  if (!op.insert) throw new TypeError("only `insert` operations can be transformed!");
  if (typeof op.insert === "string") {
    return text + op.insert;
  } else if (op.insert.VariableTag) {
    // @ts-ignore
    return text + (op.insert.VariableTag.marker || " ");
  }
  return `${text} `;

}, "") as string;

export const quillDeltaToHtml = (delta: Delta): string => {
  const qdhc = new QuillDeltaToHtmlConverter(delta.ops, {});
  qdhc.renderCustomWith((customOp) => {
    if (customOp.insert.type === "VariableTag") {
      const val = customOp.insert.value;
      return val.marker;
    }
    return null;
  });
  return qdhc.convert();
};
